var foo = 1;
console.log(foo);
var baz = function () {};
console.log(baz);
